import { Component, ChangeDetectionStrategy } from '@angular/core';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { SiteCredentials } from '@myrtls/api-interfaces';
import { AppState } from '../../store';
import { $siteCredentials } from '../../store/deployment/deployment.selectors';

interface CredentialItem {
    key: string;
    label: string;
    value: string | null;
}

@Component({
    selector: 'myrtls-credentials',
    templateUrl: './credentials.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class CredentialsComponent {
    credentialItems$ = this.store
        .select($siteCredentials)
        .pipe(
            map(credentials =>
                credentials ? this.toItems(credentials) : null,
            ),
        );

    visibleFields: { [key: string]: boolean } = {};

    constructor(private readonly store: Store<AppState>) {}

    toggleVisibility(key: string): void {
        this.visibleFields[key] = !this.visibleFields[key];
    }

    isVisible(key: string): boolean {
        return !!this.visibleFields[key];
    }

    copyToClipboard(value: string): void {
        navigator.clipboard.writeText(value);
    }

    private toItems(credentials: SiteCredentials): CredentialItem[] {
        return [
            {
                key: 'influxWriteToken',
                label: 'InfluxDB Write Token',
                value: credentials.influxWriteToken,
            },
            {
                key: 'insightsPassword',
                label: 'Insights Password',
                value: credentials.insightsPassword,
            },
            {
                key: 'insightsBiPassword',
                label: 'Insights BI Password',
                value: credentials.insightsBiPassword,
            },
            {
                key: 'deviceCareLocalPassword',
                label: 'Device Care Local Password',
                value: credentials.deviceCareLocalPassword,
            },
        ];
    }
}
